import api from "../service/comprovanteSolicitacao.service";
import * as types from "./comprovanteSolicitacao.actionTypes";
import comprovanteSolicitacaoctions from "./comprovanteSolicitacao.actions";
import { takeEvery, call, put } from "redux-saga/effects";
const fileManagerRoute = window.api_routes.smarAPD_FileManager_Domain;


export default workSaga;

function* workSaga() {
  yield takeEvery(types.GET_COMPROVANTE_SOLICITACAO, getComprovanteSolicitacao);
  yield takeEvery(types.GET_IMPRIMIR_COMPROVANTE, getImprimirComprovante);
}

function* getComprovanteSolicitacao(action) {
  const { payload } = action;
  const result = yield call(api.getById, payload);

  yield put(comprovanteSolicitacaoctions.setComprovanteSolicitacao(result.data.Comprovante));
}

function* getImprimirComprovante({ payload }) {
  let dto = {
    IdDecaSolicitacao: payload,
  };
  const result = yield call(api.imprimirComprovante, dto);

  if (result.data.Success) {
    const destino = '_blank';
    window.open(
      `${fileManagerRoute}/FileManager/TB/DownloadReportTB?fileName=${result.data.FileName}&viewInBrowser=true`,
      destino
    );
  } else _alert.error(result.data.Error);

}
